import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const statisticsSchema = z.object({
  views: z.number().int().default(0),
  downloads: z.number().int().default(0),
  viewCount: z.number().int().default(0),
  downloadCount: z.number().int().default(0),
  sources: z.record(z.number()).optional(),
  geography: z.record(z.number()).optional(),
});

export class StatisticsDto extends createZodDto(statisticsSchema) {}
